<template>
  <sidebar class="kitty-sidebar settings-sidebar">
    <sidebar-list>
      <sidebar-item
        icon="fa-user-circle"
        title="Profile"
        :to="{ name: 'Profile' }"
        exact />
      <sidebar-item
        icon="fa-lock"
        title="Settings"
        :to="{ name: 'Settings' }"
        :active="subIsActive('/settings')"
        exact />
    </sidebar-list>
  </sidebar>
</template>

<script>
export default {
  name: 'SettingsSidebar',
  components: {},

  props: {},

  data () {
    return {}
  },
  computed: {},

  watch: {},

  created () {},
  mounted () {},
  updated () {},
  destroyed () {},

  methods: {
    // For parent `sidebar-item` require this function to check the path to activate the visible and active states
    // Check if the sub item href includes the input result
    subIsActive (input) {
      const paths = Array.isArray(input) ? input : [input]
      const pathArr = this.$route.path.split('/')
      // Third part of the path reepresents which layer in management-web
      return paths.some(path => (`/${pathArr[2]}` === path))
    }
  }
}
</script>
